import React from 'react';
import { Skeleton } from 'is24-corecss';

const LoadingFallback = () => (
  <div className='display-flex flex-column gap-l'>
    <Skeleton type='rounded' height='30px' width='60%' />
    <div className='display-flex flex-column gap-s'>
      <Skeleton type='rounded' height='18px' width='10%' />
      <Skeleton type='rounded' height='22px' width='40%' />
      <Skeleton type='rounded' height='40px' width='100%' />
    </div>
    <div className='display-flex flex-column gap-s'>
      <Skeleton type='rounded' height='18px' width='10%' />
      <Skeleton type='rounded' height='22px' width='40%' />
      <Skeleton type='rounded' height='40px' width='100%' />
    </div>
  </div>
);

export default LoadingFallback;
